import { defineVariants } from 'zl-shared/dist/ab-test';

const EXPERIMENTS = {
  control: {
    name: 'control',
    variants: [
      { name: 'a', weight: 1 },
      { name: 'b', weight: 1 },
    ],
  },
} as const;

Object.values(EXPERIMENTS).forEach((experiment) => {
  defineVariants(
    experiment.name,
    experiment.variants.map((v) => v.name),
    experiment.variants.map((v) => v.weight),
  );
});

export type ExperimentKey = keyof typeof EXPERIMENTS;

type VariantOfExperiment<T extends ExperimentKey> = (typeof EXPERIMENTS)[T]['variants'][number]['name'];
export type ControlTestVariant = VariantOfExperiment<'control'>;

export default EXPERIMENTS;
